interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="w-full py-16 px-6 flex flex-col items-center justify-center text-center rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl leading-none`} />
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600 leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}